module.exports = __webpack_public_path__ + "static/img/n11-132.38ef608.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/n11-132.jpg
// module id = 3hRV
// module chunks = 2